import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import "../css/omstyle.css";
import AccordionReact from 'devextreme-react/accordion';
import OMTransactionSearchResult from "./OMTransactionSearchResult";
import CreateTransaction from './Create-Transaction';
import ChangeTransaction from './change-transaction';
import { useLocation } from 'react-router-dom';
import { fetchTransactionData } from '../services/OMService'
import AutoCompleteComponent from '../services/AutoCompleteComponent'
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import { GetFormatedDateWithTime } from '../../common/Utils'
import { LoadPanel } from 'devextreme-react/load-panel';
import { useParams } from 'react-router-dom';
import ViewTransaction from './view-transaction';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useHistory } from 'react-router-dom';
//import Item from "../../so/components/Calculators/BareRootPickListItem";
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
function OMTransactionSearchForm(props) {
  var accessToken = props.oidc.user.access_token;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get('id');
  const history = useHistory();
  const [showIndicator, setShowIndicator] = useState(true);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const position = { of: '#accordion-containe2' };
  const location = useLocation();
  const [selectedItems, setSelectedItems] = useState([]);
  const [openLookupShipperTo, setOpenLookupShipperTo] = useState(false);
  const [selectedTab, setSelectedTab] = useState(props.selectedTab);
  const [dataSource, setDataSource] = useState(null);
  const [resetTrigger, setResetTrigger] = useState(false);
  const SHIPPER_ID_TO = "shipperidto";
  const lookups = {};
  lookups[SHIPPER_ID_TO] = {
    name: "ShipperTo",
    label: "Ship To:",
    lookupType: 5
  };
  const [transactionFrom, setTransactionFrom] = useState('');
  const ontransactionFromChange = useCallback(
    (e) => {
      setTransactionFrom(e.value);
    },
    [setTransactionFrom],
  );
  const [transactionTo, setTransactionTo] = useState('');
  const ontransactionToChange = useCallback(
    (e) => {
      setTransactionTo(e.value);
    },
    [setTransactionTo],
  );
  const [poNumber, setPoNumber] = useState('');
  const onpoNumberChange = useCallback(
    (e) => {
      setPoNumber(e.value);
    },
    [setPoNumber],
  );
  const [tDateTo, settDateTo] = useState('');
  const ontDateToChange = useCallback(
    (e) => {
      settDateTo(e.value);
    },
    [settDateTo],
  );
  const [tDateFrom, settDateFrom] = useState('');
  const ontDateFromChange = useCallback(
    (e) => {
      settDateFrom(e.value);
    },
    [settDateFrom],
  );
  const [sDateFrom, setsDateFrom] = useState('');
  const onsDateFromChange = useCallback(
    (e) => {
      setsDateFrom(e.value);
    },
    [setsDateFrom],
  );
  const [sDateTo, setsDateTo] = useState('');
  const onsDateToChange = useCallback(
    (e) => {
      setsDateTo(e.value);
    },
    [setsDateTo],
  );
  const handelOpenLookupShipperTo = () => {
    setOpenLookupShipperTo(true);
  }
  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      props.searchPanelData((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );
  const onInputChange = (e) => {
    setSearchQuery({ ...searchQuery, [e.target.name]: e.target.value });
  };
  const onSearchTransaction = async (e) => {
    e.preventDefault();
  };
  const handelSearch = async (e) => {
    try {
     e.event.stopPropagation();
     fetchData();
    } catch (error) {
      console.error('Error fetching transaction data:', error);
    } finally {
    }
  }

  const [searchQuery, setSearchQuery] = useState({
    transactionnumberfrom: "",
    transactionnumberto: "",
    transactionDatefrom: "",
    transactionDateto: "",
    shippingdatefrom: "",
    shippingdateto: "",
    shippernameto: "",
  });
  const {
    transactionnumberfrom,
    transactionnumberto,
    transactionDatefrom,
    transactionDateto,
    shippingdatefrom,
    shippingdateto,
  } = searchQuery;
  const handelReset = (e) => {
    try {
      e.event.stopPropagation();
      setSearchQuery({
        transactionnumberfrom: "",
        transactionnumberto: "",
        ponumber: "",
        transactionDatefrom: "",
        transactionDateto: "",
        shippingdatefrom: "",
        shippingdateto: "",
        shippernameto: "",
      });
      // const inputElements = document.querySelectorAll('.dx-texteditor-input');
      // inputElements.forEach((inputElement) => {
      //   inputElement.value = '';
      // });
      setDataSource(null);
      setTransactionFrom('');
      setTransactionTo('');
      setPoNumber('');
      settDateTo('');
      settDateFrom('');
      setsDateFrom('');
      setsDateTo('');
      setResetTrigger(prevState => !prevState);
    }
    catch (error) {
    }
    finally {
    }
  }
  useEffect(()=>{
    fetchData();
  },[props.selectedTab,history.location])
const fetchData=async ()=>{
  const resultData = await fetchTransactionData(searchQuery, accessToken, selectedTab, transactionFrom
    , transactionTo, poNumber, GetFormatedDateWithTime(tDateTo), GetFormatedDateWithTime(tDateFrom),
    GetFormatedDateWithTime(sDateTo), GetFormatedDateWithTime(sDateFrom));
    props.searchData(resultData);
}
  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          {location.pathname === '/om/transaction/create-transaction' ? (
            <CreateTransaction selectedTab={selectedTab} />
          ) : location.pathname === '/om/transaction/change-transaction' ? (
            <ChangeTransaction selectedTab={selectedTab} id={id} />
          ) : location.pathname === '/om/transaction/view-transaction' ? (
            <ViewTransaction selectedTab={selectedTab} id={id} />
          ) :  (
            <div id="accordion" >
              <form  onSubmit={(e) => onSearchTransaction(e)}>
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={300}
                  selectedItems={selectedItems}
                  onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                      selectionChanged(e, e.target);
                    }
                  }}
                  className="accordion-height"
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          {selectedTab === "Quote" ? "Enter Your Query For Quote" : "Enter Your Query For Order"}
                        </h6>
                      </div>
                      </Item>

                     <Item location="after">
                     <Button onClick={handelSearch} className="accordianButton" text="Search" type="default"/>
                     </Item>
                       <Item location="after">
                       <Button onClick={handelReset} className="accordianButton" text="Reset"/>
                       </Item>
                       

                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row">
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No. From:"
                            defaultValue=""
                            
                            value={transactionFrom}
                            onValueChanged={ontransactionFromChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction No. To:"
                            defaultValue=""
                           
                            value={transactionTo}
                            onValueChanged={ontransactionToChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Po Number contains:"
                            defaultValue=""
                           
                            value={poNumber}
                            onValueChanged={onpoNumberChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date from:"
                            defaultValue=''
                            type="date"
                            value={tDateFrom}
                            
                            onValueChanged={ontDateFromChange}
                          />
                        </div>
                      </div>
                      <div className="row accordianLastRow">
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Transaction Date to:"
                            defaultValue=''
                            type="date"
                            value={tDateTo}
                            onValueChanged={ontDateToChange}
                          />

                        </div>
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Shipping date from:"
                            defaultValue=''
                            type="date"
                            value={sDateFrom}
                            onValueChanged={onsDateFromChange}
                          />
                        </div>
                        <div className="col-md-3">
                          <DateBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Shipping date to:"
                            defaultValue=''
                            type="date"
                            value={sDateTo}
                            onValueChanged={onsDateToChange}
                          />
                        </div>
                        <div className="col-md-3 d-flex align-items-center">
                          <AutoCompleteComponent
                            lookupInfo={lookups["shipperidto"]}
                            openLookupForm={openLookupShipperTo}
                            setOpenLookupForm={setOpenLookupShipperTo}
                            setFormData={setSearchQuery}
                            formData={searchQuery}
                            resetTrigger={resetTrigger}
                          />
                          <Button
                            icon="search"
                            onClick={handelOpenLookupShipperTo}
                            stylingMode="text"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  id="accordion-container"
                />
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMTransactionSearchForm);